// 事件处理函数
// import eventHandler from '@/components/tools/extend/event.js'
export default {
  // 组件名， module 下的a组件， config.componentAcPrefix = ac 为 公用的业务组件
  name: 'ac-word-cloud',
  data () {
    return {
      // 图表类型
      myEchart: null,
      dataList: [{
        name: '',
        value: 100
      }],
      // 图表配置项
      options: {
        tooltip: {
          show: false
        },
        series: [{
          type: 'wordCloud',
          sizeRange: [16, 50],
          height: '100%',
          width: '100%',
          rotationRange: [0, 90],
          rotationStep: 90,
          gridSize: 10,
          // drawOutOfBound: false,
          textPadding: 0,
          textStyle: {
            color: function () {
              return 'rgb(' + [
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160)
              ].join(',') + ')'
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: '#333'
            }
          }
        }]
      }
    }
  },
  // 创建元素
  mounted () {
    this.init()
    window.addEventListener('resize', this.resizeHandler)
    if (this.myEchart) {
      this.myEchart.on('click', this.clickItem)
    }
  },
  // 销毁
  destroyed () {
    // 销毁图表
    this.destroyedChart()
  },
  // 方法定义
  methods: {

    /**
         * @description 初始化的方法
         * @name init
         * @return {*} 无
         */
    init () {
      // 更新数据
      this.update(this.dataList)
    },

    /**
         * @description 刷新图表
         * @return {*} 无
         */
    refresh () {
      if (this.myEchart) {
        this.myEchart.resize()
      }
    },

    clickItem (paramas) {
      this.$emit('clickWord', paramas.data)
    },

    /**
         * @description 更新
         * @name update
         * @return {*} 无
         */
    update (data) {
      // 如果不存在echarts
      if (!this.myEchart) {
        // 图表对象
        this.myEchart = this.$echarts.init(this.$refs.jsEchart)
        // 绑定resize 事件
        this.bindResizeEvent()
      }
      // 更新数据
      this.updateData(data)
      // 清空图表
      this.myEchart.clear()
      // 生成图表
      this.myEchart.setOption(this.options)
    },

    /**
         * @description 更新数据
         * @name updateData
         * @param {object} data 参数
         * @return {*} 无
         */
    updateData (data) {
      // 对数据进行赋值
      this.options.series[0].data = data
    },

    /**
         * @description 事件处理函数
         * @name resizeHandler
         * @return {*} 无
         */
    resizeHandler () {
      if (this.myEchart) {
        this.myEchart.resize()
      }
    },

    /**
         * @description 绑定resize 事件
         * @name init
         * @return {*} 无
         */
    bindResizeEvent () {
      // 绑定resize事件
      // eventHandler.on(window, 'resize', this.resizeHandler)
    },
    // 取消事件绑定
    unbindResizeEvent () {
      // 取消绑定resize事件
      // eventHandler.off(window, 'resize', this.resizeHandler)
    },

    /**
         * @description 销毁图表
         * @name destroyedChart
         * @return {*} 无
         */
    destroyedChart () {
      // 如果存在echarts
      if (this.myEchart) {
        // 销毁实例，销毁后实例无法再被使用。
        this.myEchart.dispose()
        this.myEchart = null
        // 取消事件绑定
        this.unbindResizeEvent()
      }
    }
  }
}
